<vsn-navigation [lang]="vsnLang" [auth]="vsnAuth" [tree]="vsnTree" [showHelp]="true" [notificationActive]="isNotificationActive"
    [showNotification]="true" [helpUrl]="vsnHelpUrl" [landingPageUrl]="vsnLandingPageUrl" [modules]="vsnModules"
    [feedback]="vsnFeedback">

    <div slot="context-selector">
        <p-autoComplete [suggestions]="contextGroups" [(ngModel)]="selectedContext" [group]="true"
            (completeMethod)="onSearchContext($event)" (onSelect)="onSelectContext($event)" (onBlur)="onBlurContext()"
            [dropdown]="true" [placeholder]="message['searchByName']" dropdownIcon="vismaicon vismaicon-autocomplete"
            [dropdownAriaLabel]="message['ariaLabelOpen']" [minLength]="3" optionLabel="name" [showEmptyMessage]="true"
            [scrollHeight]="'200px'" appendTo="body" [pt]="{ overlay: { class: 'combobox-dropdown on-body' }  }"
            [emptyMessage]="message['noResultsFound']" class="nc-combobox-element nc-combobox ga-autocomplete"
            (onFocus)="onFocus($event)">
            <ng-template let-group #group>
                @if(group.type !== 'none'){
                <div class="group-label"><span>{{group.label}}</span></div>
                }
            </ng-template>
        </p-autoComplete>
    </div>

    <ng-content></ng-content>

    <div class="assistant-popover-container" [attr.data-open]="isGaiaChatOpen">
        <aside id="chatDrawer">
            <gaia-chat id="assistant" #gaiaChat [attr.profile-id]="profileId" [attr.base-url]="baseUrl"
                [attr.lang]="lang" auth-strategy="visma" closeable>
            </gaia-chat>
        </aside>
    </div>

    <div class="notification-panel-popover-container" [attr.data-open]="isNotificationPanelOpen">
        @if (isNotificationPanelOpen) {
        <aside class="notification-panel-drawer" role="dialog"
            [attr.aria-label]="message['headerNotifications'] || 'Notifications'" tabindex="-1">
            <adminui-latest-export [message]="message"></adminui-latest-export>
        </aside>
        }
    </div>

</vsn-navigation>